import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    showCart: { type: Boolean, default: false }
  }

  connect() {
    if ( this.showCartValue ) {
      this.showMainCart();
    }
  }

  showMainCart() {
    const mainCart = document.querySelector("#main-cart");
    mainCart.classList.add("active");

    if (mainCart.classList.contains("body-hidden")) {
      document.body.classList.add("overflow-hidden-mobile");
    } else {
      setTimeout(() => {
        mainCart.classList.remove("active");
      }, 4000);
    }
  }

  hideMainCart(event) {
    const mainCart = document.querySelector("#main-cart");
    mainCart.classList.remove("active");
    document.body.classList.remove("overflow-hidden-mobile");
  }
}
